module.exports = __webpack_public_path__ + "static/media/eye9.a523cea8.jpeg";